<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :starting-stock-balance="form.balance"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <p>{{ JSON.stringify(form) }}</p>
          <div
            v-for="(value, key, index) in labels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset class="form-group__fieldset">
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                placeholder="Отсутствует"
                :maxlength="maxLength[key]"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <div class="col-lg-12 form-group">
        <label class="control-label">
          Изображение
          <label v-if="actionType !== 'read'" class="field__label_required">
            *
          </label>
        </label>
        <ImageInput
          :preview-image="previewImage"
          :only-preview-image="actionType === 'read'"
          @on-select-file="setImage"
          @on-delete="deleteImage"
        />
      </div>
      <div class="col-lg-6">
        <BarcodeGenerator
          :actions-are-visible="actionType !== 'read'"
          :init-value="form.barcode"
          @on-save="(barcode) => form.barcode = barcode"
        />
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import ImageInput from "@/_shared/features/form/ImageInput";
import BarcodeGenerator from "@/_shared/features/form/BarcodeGenerator";
import Form from "@/_shared/widgets/Form";

import { useForm, useNotification, useImageField } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useImageField,
  ],
  components: {
    ImageInput,
    BarcodeGenerator,
    Form,
  },
  data() {
    return {
      fallbackLink: "/cut_of_clothes",
      entityName: {
        readonly: "Крой",
        modify: "кроя",
      },
      form: createFromKeys(formsFields.cutOfClothes.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    const callback = stockComponentService.get("cut_of_clothes");
    await this.setFormFields(addingFields, callback).then(() => {
      this.checkPreviewImageExistence();
    });
  },
  computed: {
    maxLength() {
      return formsFields.cutOfClothes.maxlength;
    },
    labels() {
      const { labels } = formsFields.cutOfClothes;
      const { name, vendor_code, type } = labels;
      return { name, vendor_code, type };
    },
    validationSchema() {
      return schemas.cutOfClothes;
    },
  },
  methods: {
    async submit() {
      const callback = async () => {
        return await this.prepareImage()
          .then(async (image) => {
            return await stockComponentService[this.actionType](
              this.form, "cutOfClothes", image,
            );
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/CutOfClothesForm.vue